<template>
  <div class="footer-wrapper">
    <div class="footer">
        <span>Delivered by</span>&nbsp;
        <a class="footer-link" target="_blank" rel="noopener" :href="`https://${this.domain}/`">VCV</a>&nbsp;
        <span>with 💚</span>
    </div>
  </div>
</template>

<script>

  import { mapState } from 'vuex'

  export default {
    name: 'response-footer',
    computed: {
      ...mapState(['locale']),
      publicResponse() {
        return this.$store.getters['response/publicResponse'];
      },
      companyLang() {
        if (!this.publicResponse || !this.publicResponse.company || !this.publicResponse.company.language) {
          return null;
        }

        return this.publicResponse.company.language.code;
      },
      domain() {
        let lang = '';
        if (this.companyLang) {
          lang = this.companyLang;
        } else {
          lang = this.locale ? this.locale.value : 'en';
        }

        switch (lang) {
          case 'ru':
            return 'vcv.ru';
          case 'ja':
            return 'vcv.co.jp';
          default:
            return 'vcv.ai';
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/queries.scss';
@import '@/styles/variables.scss';

.footer-wrapper {
  position: relative;
  background-color: #fff;
  border-top: 1px solid #d2d6e0;
  min-height: 40px;
  box-sizing: border-box;
  padding: 20px 0;
  margin-top: auto;
  margin-bottom: 0;
  display: flex;
  justify-content: center;

  .footer {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 19px;
    color: #607183;

    // @include widescreen {
    //   max-width: 1200px;
    // }

    @include desktop {
      max-width: 970px;
    }

    @include tablet {
      max-width: 920px;
      padding-left: 20px;
      padding-right: 20px;
    }

    .footer-link {
      color: $green;
      font-weight: 500;
    }
  }
}

// IE-FIX
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .footer-wrapper {
    position: absolute;
    bottom: 0px;
    width: 100%;
  }
}
</style>
